import { render } from "./RuleFormView.vue?vue&type=template&id=0757f0b1"
import script from "./RuleFormView.vue?vue&type=script&lang=js"
export * from "./RuleFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleForm/RuleFormView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0757f0b1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0757f0b1', __exports__)) {
    api.reload('0757f0b1', __exports__)
  }
  
  module.hot.accept("./RuleFormView.vue?vue&type=template&id=0757f0b1", () => {
    api.rerender('0757f0b1', render)
  })

}


export default __exports__